<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <v-select
          v-model="selected1"
          v-if="authors.length > 0"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="authors"
          label="name"
        >
          <template #option="{ name, photo }">
            <b-avatar size="40" :src="photo" class="mr-1" />
            <span>{{ name }}</span>
          </template>
        </v-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup, BAvatar } from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BAvatar
  },
  props: {
    initialAuthor: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      authors: [],
      selected1: null,
     
    }
  },
  created: async function () {
    await this.fetchInstructors()
    this.selected1 = this.initialAuthor[0] || null
  },
  methods: {
    fetchInstructors() {
      return axios
        .get('/lms/admin/course/getallinstructors', {
          params: { roleid: 7 }
        })
        .then((response) => {
          this.authors = response.data.data
        })
        .catch((error) => {
          console.error('Fetch instructors failed', error)
        })
    }
  },
  watch: {
    selected1(newVal) {
      this.$emit("authorChanged", newVal)
    }
  }
}
</script>
